import { isOrderUnconfirmed } from '@bagonboard/wiseman';
import CircularProgress from '@material-ui/core/CircularProgress';
import React, { useEffect, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useHistory, useParams } from 'react-router-dom';

import { useOrder } from '#views/Dashboard/hooks';
import CardBody from '#components/Card/CardBody';
import Snackbar from '#components/Snackbar/Snackbar';
import { copyToClipBoard } from '#providers/clipBoardUtils';
import {
  CustomerInfo,
  Header,
  Invoice,
  PaymentInfo,
  ServicesSummary,
  TopContainer,
} from './components';
import {
  CardWrapper,
  Container,
  CustomerPaymentContainer,
  Footer,
  InvoiceButton,
  Margin,
  PaymentLink,
  PaymentLinkContainer,
} from './style';

function Order() {
  const { order, update, handlers: orderHandlers } = useOrder();
  const history = useHistory();
  const params = useParams();
  const [snackVisible, setSnackVisible] = useState();
  const [invoiceVisible, setInvoiceVisible] = useState(false);

  useEffect(
    () => {
      orderHandlers.fetch(params.id, {
        enableSnackbar: true,
        query         : {
          expand: ['promo', 'resellerCompany', 'services'],
        },
      });
    },
    [params.id, orderHandlers.fetch]
  );

  if (order.loading || !order.data) {
    return (
      <SweetAlert
        confirmBtnStyle={{ display: 'none' }}
        show={order.loading || update.loading}
        title=""
        onConfirm={() => {}}
      >
        <CircularProgress />
      </SweetAlert>
    );
  }

  const {
    data: {
      _id: id,
      bookingCode,
      customer,
      invoices,
      promo: { code: promoCode = '' } = {},
      resellerCompany: { name: resellercompanyName } = {},
      services,
      status,
      token,
    },
  } = order;

  const copyPaymentURL = () => {
    const paymentUrl = `${process.env.REACT_APP_BOOKING_BOB}payment?order=${id}${
      token ? `&token=${token}` : ''
    }`;
    copyToClipBoard(paymentUrl);
    setSnackVisible(true);
    setTimeout(() => {
      setSnackVisible(false);
    }, 5000);
  };

  const onInvoiceClick = () => {
    setInvoiceVisible(!invoiceVisible);
  };

  return (
    <>
      <Container>
        <TopContainer orderId={id} orderStatus={status} services={services} />
        <CardWrapper>
          <CardBody>
            <Header history={history} bookingCode={bookingCode} status={status} />
            <CustomerPaymentContainer>
              <CustomerInfo customer={customer} orderId={id} />
              <PaymentInfo invoices={invoices} promoCode={promoCode} seller={resellercompanyName} />
              {isOrderUnconfirmed({ status }) && (
                <PaymentLinkContainer>
                  {'Would you like to copy a url to send to the customer to complete the payment? '}
                  <PaymentLink onClick={copyPaymentURL}>Copy URL</PaymentLink>
                </PaymentLinkContainer>
              )}
            </CustomerPaymentContainer>
            <ServicesSummary services={services} history={history} />
            <Footer>
              <Margin />
              <InvoiceButton onClick={onInvoiceClick} variant="outlined">
                SEE INVOICE
              </InvoiceButton>
            </Footer>
          </CardBody>
        </CardWrapper>
      </Container>
      <Invoice open={invoiceVisible} setOpen={onInvoiceClick} />
      <Snackbar
        color="success"
        message="URL copied to your clipboard. Paste it on your preferred messaging platform to send to the client"
        open={snackVisible}
      />
      <SweetAlert
        confirmBtnStyle={{ display: 'none' }}
        show={update.loading}
        title=""
        onConfirm={() => {}}
      >
        <CircularProgress />
      </SweetAlert>
    </>
  );
}

export default Order;
